import { apiRequest } from '@/core';
import { type Event, type PaginatedResponse } from '@/types';
import { type FetchEventsRequestParams } from './types';

export const fetchEventsRequest = async ({
  propertyId,
  pagination,
  filters: { statusIds, typeIds, search, startDate } = {},
}: FetchEventsRequestParams) =>
  apiRequest<PaginatedResponse<Event>>({
    endpoint: `api/events/${propertyId}`,
    params: {
      ...pagination,
      statusIds,
      typeIds,
      search,
      startDate,
    },
  });
